// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listItem__b3e.listItem__b3e {
  padding-left: calc(4 * var(--ring-unit)) !important;
}

.listItemHovered__e1d.listItemHovered__e1d {
  background-color: var(--ring-hover-background-color);
}

.listItemSelected__ca9 {
  background-color: var(--ring-selected-background-color);
}

.listItemTitle__d42 {
  margin: var(--ring-unit) 0;
}
`, "",{"version":3,"sources":["webpack://./src/common/app-layout/sidebar/sidebar-menu/sidebar-menu.css"],"names":[],"mappings":"AAAA;EACE,mDAAmD;AACrD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".listItem.listItem {\n  padding-left: calc(4 * var(--ring-unit)) !important;\n}\n\n.listItemHovered.listItemHovered {\n  background-color: var(--ring-hover-background-color);\n}\n\n.listItemSelected {\n  background-color: var(--ring-selected-background-color);\n}\n\n.listItemTitle {\n  margin: var(--ring-unit) 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listItem": `listItem__b3e`,
	"listItemHovered": `listItemHovered__e1d`,
	"listItemSelected": `listItemSelected__ca9`,
	"listItemTitle": `listItemTitle__d42`
};
export default ___CSS_LOADER_EXPORT___;
